/* Same for prerenderSlides
  prerenderSlides = [{
            large: require('/public/images/rtic/pdp/ultra-light/featured-image.jpg'),
            medium: require('/public/images/rtic/pdp/ultra-light/featured-image.jpg'),
            thumb: require('/public/images/rtic/pdp/ultra-light/featured-image.jpg'),
          }]
*/

import { ProductTypeId } from '@types';

export const getPDPV2Data = (type) => {
  switch (type) {
    case ProductTypeId.TUMBLER_TYPE:
      return {
        featureCards: {
          title: 'GET READY TO TUMBLE',
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/tumblers/made-for-extremes.jpg'),
              title: 'Made For The Extremes',
              description: `<p>Stainless steel construction means you can take this ultra-durable tumbler from the heart of Death Valley to the highest peaks of the Himalayas.</p>`,

              bgColor: '#C5B38D',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/tumblers/max-temp.jpg'),
              title: 'Maximum Temperature Retention',
              description: `<p>This tumbler is equipped with double-wall vacuum insulation, so your hot drinks stay hot and cold drinks stay cold.</p>`,
              bgColor: '#EAE28D',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/tumblers/ideal-travel.jpg'),
              title: 'The Ideal Travel Companion',
              description: `<p>The cup holder-friendly design means this tumbler can tag along with you wherever you go.</p>`,
              bgColor: '#CAC6DE',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/tumblers/protect-drinks.jpg'),
              title: 'Protects Your Drink At All Costs',
              description: `<p>The splash-proof lid keeps your beverages intact from the commute to the campsite.</p>`,
              bgColor: '#185E5F',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.ANYWHERE_BLANKET:
      return {
        featureCards: {
          title: 'Meet the Anywhere Blanket',
          items: [
            {
              videoUrl:
                'https://storage.googleapis.com/static.velkybrands.com/v/anywhere-blanket_shake-it-off_d.mp4',
              imageUrl: require('./images/anywhere-blanket/shake-it-off-poster_d.jpg'),
              imageUrlMob: require('./images/anywhere-blanket/shake-it-off-poster_m.jpg'),
              title: 'Shake it Off',
              description: `<p>The rugged, water- and stain-repellent top fabric makes it easy to shake off any pet hair, dirt, grass, and spills. 
              <br /><br />
              Note: Although the bottom fabric may appear wet, it is fully waterproof and will keep you dry and comfortable on damp, sandy, and other dirty surfaces.</p>`,

              bgColor: '#055774',
              textColor: '#fff',
            },
            {
              imageUrl: require('./images/anywhere-blanket/anywhere-you-go_d.jpg'),
              imageUrlMob: require('./images/anywhere-blanket/anywhere-you-go_m.jpg'),
              title: 'Anywhere You Go',
              description: `<p>The convenient, built-in handle and webbing straps make it easy to roll the blanket back into itself for portability and storing.
              <br /><br />
              Simply fold your blanket in thirds, secure it, and toss it in the back of your car.</p>`,
              bgColor: '#C7C7BE',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('./images/anywhere-blanket/perfect-size_d.jpg'),
              imageUrlMob: require('./images/anywhere-blanket/perfect-size_m.jpg'),
              title: 'The Perfect Size',
              description: `<p>Whether you’re setting up a picnic in the park, watching the fireworks, or getting cozy—the Anywhere blanket is big enough to sit on with friends or wrap around two people.</p>`,
              bgColor: '#B24A1B',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.EVERYDAY_INSULATED_TOTE:
      return {
        featureCards: {
          title: 'Meet the Everyday Insulated Tote',
          items: [
            {
              imageUrl: require('./images/everyday-insulated-tote/keeping-it-fresh_d.jpg'),
              imageUrlMob: require('./images/everyday-insulated-tote/keeping-it-fresh_m.jpg'),
              title: 'Keeping it Fresh',
              description: `<p>The durable, fully-insulated interior with welded seams keeps your food fresh whether it’s on the way home from the grocery store, for snacks at the soccer game, or a long day at the lake.`,

              bgColor: '#A9C1BC',
              textColor: '#1F1F1F',
            },
            {
              videoUrl: 'https://static.velkybrands.com/v/everday-insulated-tote_essential_d.mp4',
              videoUrlMob: 'https://static.velkybrands.com/v/everday-insulated-tote_essential_m.mp4',
              imageUrl: require('./images/everyday-insulated-tote/an-everyday-essential-fallback_d.jpg'),
              imageUrlMob: require('./images/everyday-insulated-tote/an-everyday-essential-fallback_m.jpg'),
              title: 'An Everyday Essential',
              description: `<p>The fully waterproof base keeps your tote upright while protecting from wet, grassy, and sandy surfaces. Once you’re done, it can be folded flat for easy storing—in the back seat or pantry.</p>`,
              bgColor: '#435966',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.HARD_COOLER_65_QT_TYPE:
      return {
        tagline: 'Wirecutter Award Pick',
        featureCards: {
          title: 'MEET THE 65 QT HARD COOLER',
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/65-qt-hard-cooler/unlimited-potential.jpg'),
              title: 'Wirecutter Pick',
              description: `
                <p>
                  <i>
                    <b>“The RTIC is practically indestructible, which makes it great for tougher outdoor environments. In our testing, the RTIC kept ice frozen for 10 days”</b>
                  </i> - Wirecutter
                </p>
                `,
              bgColor: '#CDB292',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/65-qt-hard-cooler/long-live-the-ice.jpg'),
              title: 'Long Live The Ice',
              description: `<p>3-inch foam insulated walls provide durability and long lasting ice retention.</p>`,
              bgColor: '#A0D7DB',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/65-qt-hard-cooler/ready-for-road.jpg'),
              title: 'Ready For The Road',
              description: `<p>Use the heavy-duty rope handles to take the 65 QT anywhere and when you need an extra hand—this cooler doubles as a step stool, or tabletop.</p>`,
              bgColor: '#C1BAA3',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/65-qt-hard-cooler/heavy-duty.jpg'),
              title: 'Heavy-Duty Protection',
              description: `
                    <p>
                      The combination of durable rubber T-latches and molded tie-down slots will keep your food and
                      beverages safe and secure.
                    </p>

                    <p>
                      Rotomolded construction makes it tough enough to handle every excursion—from fishing trips to
                      weekends in the desert.
                    </p>
                  `,
              bgColor: '#D7B497',
              textColor: '#1f1f1f',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.HARD_COOLER_110_QT_TYPE:
      return {
        featureCards: {
          title: 'MEET THE 110 QT HARD COOLER',
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/110-qt-hard-cooler/go-explore.jpg'),
              title: 'Go Explore',
              description: `
                <p>
                  Give life to every adventure with a cooler big enough to store those three-course meals or a bevy of beverages.
                </p>
              `,
              bgColor: '#815B44',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/110-qt-hard-cooler/long-live-the-ice.jpg'),
              title: 'Long Live The Ice',
              description: `<p>3-inch foam insulated walls provide durability and long lasting ice retention.</p>`,
              bgColor: '#8A967D',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/110-qt-hard-cooler/ready-for-road.jpg'),
              title: 'Ready For The Road',
              description: `
                <p>
                  Use the heavy-duty rope handles to take the 110 QT anywhere and when you need an extra hand—this cooler doubles as a step stool, or tabletop.
                </p>
              `,
              bgColor: '#314A45',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/110-qt-hard-cooler/heavy-duty.jpg'),
              title: 'Heavy-Duty Protection',
              description: `
                    <p>
                      The combination of durable rubber T-latches and molded tie-down slots will keep your food and beverages safe and secure.
                    </p>

                    <p>
                      Rotomolded construction makes it tough enough to handle every excursion—from fishing trips to weekends in the desert.
                    </p>
                  `,
              bgColor: '#D7B497',
              textColor: '#1f1f1f',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.HARD_COOLER_145_QT_TYPE:
      return {
        featureCards: {
          title: 'MEET THE 145 QT HARD COOLER',
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/145-qt-hard-cooler/go-explore.jpg'),
              title: 'Go Big',
              description: `
                <p>
                  Like a portable refrigerator, the 145 is the size you need to embrace those longer adventures you hope will never end.
                </p>
              `,
              bgColor: '#F16F3F',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/145-qt-hard-cooler/long-live-the-ice.jpg'),
              title: 'Long Live The Ice',
              description: `<p>3-inch foam insulated walls provide durability and long lasting ice retention.</p>`,
              bgColor: '#61ACCF',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/145-qt-hard-cooler/ready-for-road.jpg'),
              title: 'Ready For The Road',
              description: `
                <p>
                  Use the heavy-duty rope handles to take the 145 QT anywhere and when you need an extra hand—this cooler doubles as a step stool, or tabletop.
                </p>
              `,
              bgColor: '#5A5D14',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/145-qt-hard-cooler/heavy-duty.jpg'),
              title: 'Heavy-Duty Protection',
              description: `
                    <p>
                      The combination of durable rubber T-latches and molded tie-down slots will keep your food and beverages safe and secure.
                    </p>

                    <p>
                      Rotomolded construction makes it tough enough to handle every excursion—from fishing trips to weekends in the desert.
                    </p>
                  `,
              bgColor: '#D7B497',
              textColor: '#1f1f1f',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.PULLOVER_HOODIE_TYPE:
      return {
        featureCards: {
          title: 'MEET THE WATER-REPELLENT PULLOVER HOODIE',
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/pullover-hoodie/function-first.jpg'),
              title: 'Function First',
              description: `
                <p>
                  The ergonomic seam design means nothing gets in the way of your movement, so you can play, work, and explore better.
                </p>
              `,
              bgColor: '#9F9B7F',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/pullover-hoodie/added-warmth.jpg'),
              title: 'Added Warmth',
              description: `<p>The hood is double-lined and the knit rib cuffs feature thumbholes for extra coziness.</p>`,
              bgColor: '#394F4A',
              textColor: '#fff',
            },
            {
              videoUrl: 'https://static.velkybrands.com/v/water-repellent.mp4',
              imageUrl: require('/public/images/rtic/pdp/pullover-hoodie/meet-any-adventure.jpg'),
              title: 'Meet Any Adventure',
              description: `
                <p>
                  The outer shell utilizes water-resistant properties, to keep you dry on foggy mornings and chilly wet evenings.
                </p>
              `,
              bgColor: '#656E69',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/pullover-hoodie/travel-lighter.jpg'),
              title: 'Travel Lighter',
              description: `
                    <p>
                      Features a hidden inner mesh stash pocket with added hook and loop closure to keep your essentials secure.
                    </p>
                  `,
              bgColor: '#6A5C27',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
          },
          {
            title: 'Chest',
            values: ['36 - 38', '39 - 41', '42 - 44', '45 - 48', '49 - 51', '52 - 54'],
          },
          {
            title: 'Waist',
            values: ['28 - 30', '31 - 33', '34 - 36', '37 - 40', '41 - 43', '44 - 46'],
          },
          {
            title: 'Sleeves',
            values: ['33', '34', '35', '36', '37', '38'],
          },
        ],
        findYourFitNote: `Our hoodie sweatshirts come in an <strong>Athletic Fit</strong>. If you prefer a roomy fit, order
          one size up from your normal size.`,
      };

    case ProductTypeId.PULLOVER_HOODIE_RELAXED:
      return {
        prependSlides: [],
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
          },
          {
            title: 'Chest',
            values: ['36 - 38', '39 - 41', '42 - 44', '45 - 48', '49 - 51', '52 - 54'],
          },
          {
            title: 'Waist',
            values: ['28 - 30', '31 - 33', '34 - 36', '37 - 40', '41 - 43', '44 - 46'],
          },
          {
            title: 'Sleeves',
            values: ['33', '34', '35', '36', '37', '38'],
          },
        ],
        findYourFitNote: `Our hoodie sweatshirts come in a <strong>Relaxed Fit</strong>. We suggest you order your normal size.`,
      };

    case ProductTypeId.MENS_FULL_ZIP_HOODIE:
      return {
        featureCards: {
          title: "Meet The Men's Zip-up Hoodie",
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/mens-zip-up-hoodie/function-first.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/mens-zip-up-hoodie/function-first-mob.jpg'),
              title: 'Function First',
              description: `
                <p>
                  The ergonomic seam design means nothing gets in the way of your movement, so you can work, play, and explore better.
                </p>
              `,
              bgColor: '#EAA53D',
              textColor: '#1f1f1f',
            },
            {
              videoUrl: 'https://static.velkybrands.com/v/water-repellent.mp4',
              imageUrl: require('/public/images/rtic/pdp/mens-zip-up-hoodie/still-water.jpg'),
              title: 'Meet The Adventure',
              description: `<p>The water-resistant outer shell keeps you dry on foggy mornings and warm on chilly evenings.</p>`,
              bgColor: '#5C5899',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/mens-zip-up-hoodie/stay-comfortable.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/mens-zip-up-hoodie/stay-comfortable-mob.jpg'),
              title: 'Stay Comfortable',
              description: `
                <p>The unique collar design keeps your neck warm with or without the hood.</p>
              `,
              bgColor: '#757047',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/mens-zip-up-hoodie/travel-lighter.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/mens-zip-up-hoodie/travel-lighter-mob.jpg'),
              title: 'Travel Lighter',
              description: `
                <p>Features a hidden inner mesh stash pocket with added hook and loop closure to keep your essentials secure.</p>
              `,
              bgColor: '#075D83',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
          },
          {
            title: 'Chest',
            values: ['36 - 38', '39 - 41', '42 - 44', '45 - 48', '49 - 51', '52 - 54'],
          },
          {
            title: 'Waist',
            values: ['28 - 30', '31 - 33', '34 - 36', '37 - 40', '41 - 43', '44 - 46'],
          },
          {
            title: 'Sleeves',
            values: ['33', '34', '35', '36', '37', '38'],
          },
        ],
        findYourFitNote: `Our hoodie sweatshirts come in an <strong>Athletic Fit</strong>. If you prefer a roomy fit, order
          one size up from your normal size.`,
      };

    case ProductTypeId.MENS_R_TECH_SUN_HOODIE:
    case ProductTypeId.MENS_R_TECH_PERFORMANCE_TEES:
      return {
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
          },
          {
            title: 'Chest',
            values: ['36 - 38', '39 - 41', '42 - 44', '45 - 48', '49 - 51', '52 - 54'],
          },
          {
            title: 'Waist',
            values: ['28 - 30', '31 - 33', '34 - 36', '37 - 40', '41 - 43', '44 - 46'],
          },
          {
            title: 'Sleeves',
            values: ['33', '34', '35', '36', '37', '38'],
          },
        ],
        findYourFitNote: `
            Our R-Tech Apparel come in an <strong>Athletic Fit</strong>. If you prefer a roomy fit, order one
            size up from your normal size.`,
      };

    case ProductTypeId.RTIC_SHORT_SLEEVE_TSHIRT:
      return {
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
          },
          {
            title: 'Chest',
            values: ['36 - 38', '39 - 41', '42 - 44', '45 - 48', '49 - 51', '52 - 54'],
          },
          {
            title: 'Waist',
            values: ['28 - 30', '31 - 33', '34 - 36', '37 - 40', '41 - 43', '44 - 46'],
          },
          {
            title: 'Sleeves',
            values: ['33', '34', '35', '36', '37', '38'],
          },
        ],
        findYourFitNote: `
            Our Short Sleeve Shirt comes in a <strong>Relaxed Fit</strong>. We suggest you order your normal size.`,
      };

    case ProductTypeId.WOMENS_FULL_ZIP_HOODIE:
      return {
        featureCards: {
          title: "Meet The Women's Zip-up Hoodie",
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/womens-zip-up-hoodie/function-first.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/womens-zip-up-hoodie/function-first-mob.jpg'),
              title: 'Function First',
              description: `
                <p>
                  The ergonomic seam design means nothing gets in the way of your movement, so you can work, play, and explore better.
                </p>
              `,
              bgColor: '#BA0221',
              textColor: '#fff',
            },
            {
              videoUrl: 'https://static.velkybrands.com/v/water-running.mp4',
              imageUrl: require('/public/images/rtic/pdp/womens-zip-up-hoodie/still-water.jpg'),
              title: 'Meet The Adventure',
              description: `<p>The water-resistant outer shell keeps you dry on foggy mornings and warm on chilly evenings.</p>`,
              bgColor: '#5C5899',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/womens-zip-up-hoodie/stay-comfortable.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/womens-zip-up-hoodie/stay-comfortable-mob.jpg'),
              title: 'Stay Comfortable',
              description: `
                <p>The unique collar design keeps your neck warm with or without the hood.</p>
              `,
              bgColor: '#D5D24B',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/womens-zip-up-hoodie/travel-lighter.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/womens-zip-up-hoodie/travel-lighter-mob.jpg'),
              title: 'Travel Lighter',
              description: `
                <p>Features a hidden inner mesh stash pocket with added hook and loop closure to keep your essentials secure.</p>
              `,
              bgColor: '#735F48',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['XS | 0-2', 'S | 4-6', 'M | 8-10', 'L | 12-14', 'XL | 16-18', '2XL | 20'],
          },
          {
            title: 'Chest',
            values: ['33 - 34', '35 - 36', '37 - 38', '39 - 41', '42 - 44', '45 - 47'],
          },
          {
            title: 'Waist',
            values: ['26 - 27', '28 - 29', '30 - 31', '32 - 34', '35 - 38', '39 - 41'],
          },
          {
            title: 'Sleeves',
            values: [
              '35.5 - 36.5',
              '37.5 - 38.5',
              '39.5 - 40.5',
              '41.5 - 43.5',
              '44.5 - 46.5',
              '47.5 - 49.5',
            ],
          },
        ],
        findYourFitNote: `Our hoodie sweatshirts come in an <strong>Athletic Fit</strong>. If you prefer a roomy fit, order
          one size up from your normal size.`,
      };

    case ProductTypeId.WOMENS_R_TECH_SUN_HOODIE:
    case ProductTypeId.WOMENS_R_TECH_PERFORMANCE_TEES:
      return {
        findYourFitCharts: [
          {
            title: 'Size',
            values: ['XS | 0-2', 'S | 4-6', 'M | 8-10', 'L | 12-14', 'XL | 16-18', '2XL | 20'],
          },
          {
            title: 'Chest',
            values: ['33 - 34', '35 - 36', '37 - 38', '39 - 41', '42 - 44', '45 - 47'],
          },
          {
            title: 'Waist',
            values: ['26 - 27', '28 - 29', '30 - 31', '32 - 34', '35 - 38', '39 - 41'],
          },
          {
            title: 'Sleeves',
            values: [
              '35.5 - 36.5',
              '37.5 - 38.5',
              '39.5 - 40.5',
              '41.5 - 43.5',
              '44.5 - 46.5',
              '47.5 - 49.5',
            ],
          },
        ],
        findYourFitNote: `
            Our R-Tech Apparel come in an <strong>Athletic Fit</strong>. If you prefer a roomy fit, order one
            size up from your normal size.`,
      };

    case ProductTypeId.CAN_CHILLER:
      return {
        featuredVideo: {
          placeholderImgUrl: {
            desktop: require('/public/images/rtic/pdp/can-chiller/video-placeholder.jpg'),
            mobile: require('/public/images/rtic/pdp/can-chiller/video-placeholder-mob.jpg'),
          },
          videoUrl: {
            desktop: 'https://static.velkybrands.com/v/can-chiller_landscape.mp4',
            mobile: 'https://static.velkybrands.com/v/can-chiller_square.mp4',
          },
        },
        featureCards: {
          title: 'MEET THE CAN CHILLER',
          items: [
            {
              videoUrl: 'https://static.velkybrands.com/v/can-chiller_d.mp4',
              videoUrlMob: 'https://static.velkybrands.com/v/can-chiller_m.mp4',
              imageUrl: require('/public/images/rtic/pdp/can-chiller/unmatched-versatility.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/can-chiller/unmatched-versatility-mob.jpg'),
              title: 'Unmatched Versatility',
              description: `
                <p>
                  The spring-loaded base accommodates a wide range of your favorite canned beverages like Slim 12oz cans, Standard 12oz cans, and even Tall 16oz cans.
                </p>
              `,
              bgColor: '#615600',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/can-chiller/dont-sweat-it.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/can-chiller/dont-sweat-it-mob.jpg'),
              title: 'Don’t Sweat It',
              description: `<p>Stainless steel double-wall vacuum insulation keeps your drink cold, while the sweat-proof exterior is built for durability.</p>`,
              bgColor: '#909A97',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/can-chiller/safe-and-sealed.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/can-chiller/safe-and-sealed-mob.jpg'),
              title: 'Safe & Sealed',
              description: `
                <p>The lid slides closed, keeping dirt, sand, and even bugs out of your drink, while the cold stays in for hours.</p>
              `,
              bgColor: '#24816D',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.BOTTLE_CHILLER:
      return {
        featuredVideo: {
          placeholderImgUrl: {
            desktop: require('/public/images/rtic/pdp/bottle-chiller/video-placeholder.jpg'),
            mobile: require('/public/images/rtic/pdp/bottle-chiller/video-placeholder-mob.jpg'),
          },
          videoUrl: {
            desktop: 'https://static.velkybrands.com/v/bottle-chiller_landscape.mp4',
            mobile: 'https://static.velkybrands.com/v/bottle-chiller_square.mp4',
          },
        },
        featureCards: {
          title: 'MEET THE BOTTLE CHILLER',
          items: [
            {
              imageUrl: require('/public/images/rtic/pdp/bottle-chiller/savor-sip.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/bottle-chiller/savor-sip-mob.jpg'),
              videoUrl: 'https://static.velkybrands.com/v/bottle-chiller_d.mp4',
              videoUrlMob: 'https://static.velkybrands.com/v/bottle-chiller_m.mp4',
              title: 'Savor Every Sip',
              description: `
                <p>Double-wall vacuum insulation will keep your drink cold for up to 16 hours so your last sip will be as cold as your first.</p>
              `,
              bgColor: '#303043',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/bottle-chiller/stays-secure.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/bottle-chiller/stays-secure-mob.jpg'),
              title: 'Stays Secure',
              description: `<p>Never worry about glass-free zones again. The interior padded base acts as a cushion for your bottle, protecting it from life’s adventures.</p>`,
              bgColor: '#6D0900',
              textColor: '#fff',
            },
            {
              imageUrl: require('/public/images/rtic/pdp/bottle-chiller/level-up.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/bottle-chiller/level-up-mob.jpg'),
              title: 'Level Up',
              description: `
                <p>The cap features a built-in bottle opener, so you have everything you need to enjoy your beverage.</p>
              `,
              bgColor: '#3A3D60',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.CHILLOUT_BACKPACK_COOLER:
      return {
        featureCards: {
          title: 'MEET THE CHILLOUT BACKPACK COOLER',
          items: [
            {
              imageUrl: require('./images/chillout-backpack-cooler/crack-yourself-cold-one-desktop.jpg'),
              imageUrlMob: require('./images/chillout-backpack-cooler/crack-yourself-cold-one-mob.jpg'),
              title: 'Crack Yourself A Cold One',
              description: `
                <p>Our Chillout Backpack is outfitted with a premium, removable, stainless steel bottle opener.</p>
              `,
              bgColor: '#B2D08A',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('./images/chillout-backpack-cooler/comfortably-carried-desktop.jpg'),
              imageUrlMob: require('./images/chillout-backpack-cooler/comfortably-carried-mob.jpg'),
              title: 'Comfortably Carried',
              description: `<p>Ergonomically-shaped shoulder straps and a breathable air-mesh back panel make this pack extremely comfortable for long hauls.</p>`,
              bgColor: '#29668A',
              textColor: '#fff',
            },
            {
              imageUrl: require('./images/chillout-backpack-cooler/chillout-anywhere-desktop.jpg'),
              imageUrlMob: require('./images/chillout-backpack-cooler/chillout-anywhere-mob.jpg'),
              title: 'Chill Out Anywhere.',
              description: `
                <p>The fully insulated main cooler compartment has a sleeve that perfectly fits the custom Chillout Ice Pack (sold separately) to keep cargo cool from the trails to the shore.</p>
              `,
              bgColor: '#BBDCEF',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('./images/chillout-backpack-cooler/plentiful-storage_d.jpg'),
              imageUrlMob: require('./images/chillout-backpack-cooler/plentiful-storage_m.jpg'),
              title: 'Plentiful Storage',
              description: `
                <p>Large ventilated front stash pocket fits extra gear like towels, bathing suits or rain jackets. Smaller front pocket keeps wallet, keys, and cell phone accessible.</p>
              `,
              bgColor: '#334135',
              textColor: '#fff',
            },
          ],
          prependSlides: [],
        },
      };

    case ProductTypeId.EVERYDAY_COOLER:
      return {
        featureCards: {
          title: 'MEET THE EVERYDAY COOLER',
          items: [
            {
              videoUrl: 'https://static.velkybrands.com/v/everyday-cooler-collapse.mp4',
              imageUrl: require('/public/images/rtic/pdp/everyday-cooler/stores-small-desktop.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/everyday-cooler/stores-small-mob.jpg'),
              title: 'Stores Small',
              description: `
                <p>
                  Collapsible sides fold flat into the semi-rigid lid for compact storage.
                </p>
              `,
              bgColor: '#E39B5A',
              textColor: '#1f1f1f',
            },

            {
              imageUrl: require('/public/images/rtic/pdp/everyday-cooler/cool-all-day-desktop.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/everyday-cooler/cool-all-day-mob.jpg'),
              title: 'Keep Cool All Day',
              description: `<p>
                Fully insulated with closed cell foam for all-day cold with RTIC Ice Packs.
                <br /><br />
                <u><a href='/Ice-Packs' target="_blank">RTIC Ice Packs</a></u> sold separately
              </p>`,
              bgColor: '#7B3F3E',
              textColor: '#fff',
            },

            {
              imageUrl: require('/public/images/rtic/pdp/everyday-cooler/crack-cold-one-desktop.jpg'),
              imageUrlMob: require('/public/images/rtic/pdp/everyday-cooler/crack-cold-one-mob.jpg'),
              title: 'Crack A Cold One',
              description: `
                <p>Removable, high-quality, stainless steel bottle opener built right in.</p>
              `,
              bgColor: '#5C774E',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.ULTRA_TOUGH_TOTE:
      return {
        featureCards: {
          title: 'Meet The Ultra-Tough Tote',
          items: [
            {
              imageUrl: require('./images/ultra-tough-tote/1_d.jpg'),
              imageUrlMob: require('./images/ultra-tough-tote/1_m.jpg'),
              title: 'RTIC Tough',
              description: `
                <p>
                  This easy-to-clean, premium Tote is built with quality waterproof and puncture-resistant TPU-coated nylon fabric that makes the exterior stain and tear resistant.
                </p>
              `,
              bgColor: '#184170',
              textColor: '#fff',
            },
            {
              imageUrl: require('./images/ultra-tough-tote/2_d.jpg'),
              imageUrlMob: require('./images/ultra-tough-tote/2_m.jpg'),
              title: 'Free Standing',
              description: `
                <p>
                  A rugged, EVA molded bottom helps keep this Tote upright and easily accessible, while protecting food, drinks, and other goodies from mud and puddles.
                </p>
              `,
              bgColor: '#DDC9A1',
              textColor: '#1F1F1F',
            },
            {
              imageUrl: require('./images/ultra-tough-tote/3_d.jpg'),
              imageUrlMob: require('./images/ultra-tough-tote/3_m.jpg'),
              title: 'Adventure Ready',
              description: `
                <p>
                  Built with our legendary toughness, the Ultra-Tough Tote is perfect for farmers markets, soccer games, camping, beach days and everything in between.
                </p>
              `,
              bgColor: '#34481C',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.ROAD_TRIP_ROLLING_DUFFLE:
      return {
        tagline: 'Durably built to fit all your gear.',
        variants: {
          size: {
            Medium: {
              tagline: 'Fits in overhead bins',
            },
          },
        },
        featureCards: {
          title: 'Meet The Roadtrip Rolling Duffle',
          items: [
            {
              videoUrl: 'https://static.velkybrands.com/v/road-trip-rolling-duffle.mp4',
              imageUrl: require('./images/road-trip-rolling-duffle/1_d.jpg'),
              imageUrlMob: require('./images/road-trip-rolling-duffle/1_m.jpg'),
              title: 'Roll Into Adventure',
              description: `
                <p>
                  A telescoping handle and rolling wheels tackle smooth and rugged surfaces with ease. Plus, two padded grab handles are there for you when you’re ready to lift or carry it.
                </p>
              `,
              bgColor: '#C8DDEF',
              textColor: '#1F1F1F',
            },
            {
              imageUrl: require('./images/road-trip-rolling-duffle/2_d.jpg'),
              imageUrlMob: require('./images/road-trip-rolling-duffle/2_m.jpg'),
              title: 'RTIC Tough',
              description: `
                <p>
                  Made from rugged water- and abrasion-resistant nylon, the Road Trip Rolling Duffle keeps all your contents safe–no matter the circumstances.
                </p>
              `,
              bgColor: '#BC5414',
              textColor: '#fff',
            },
            {
              imageUrl: require('./images/road-trip-rolling-duffle/3_d.jpg'),
              imageUrlMob: require('./images/road-trip-rolling-duffle/3_m.jpg'),
              title: 'Perfect Fit',
              description: `
                <p>
                  Medium Duffles are intentionally designed to fit in airline overhead compartments, while still holding up to a week’s worth of clothes or gear for a weekend adventure.
                </p>
              `,
              bgColor: '#384455',
              textColor: '#fff',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.ROAD_TRIP_DUFFLE:
      return {
        featureCards: {
          title: 'Meet The Roadtrip Duffle',
          items: [
            {
              imageUrl: require('./images/road-trip-duffle/v2/rugged-is-understatement_d.jpg'),
              imageUrlMob: require('./images/road-trip-duffle/v2/rugged-is-understatement_m.jpg'),
              title: 'Rugged Is An Understatement',
              description: `
                <p>
                  Made with semi-rigid water resistant and abrasion resistant fabric to handle any adventure.
                </p>
              `,
              bgColor: '#0A6A95',
              textColor: '#fff',
            },
            {
              imageUrl: require('./images/road-trip-duffle/v2/pack-with-ease_d.jpg'),
              imageUrlMob: require('./images/road-trip-duffle/v2/pack-with-ease_m.jpg'),
              title: 'Pack With Ease',
              description: `<p>
                Wide mouth opening and semi-rigid fabric allow for easy access while you load or unload your gear. 
                <br /><br />
                The medium-size Road Trip Duffle fits as a carry-on.
              </p>`,
              bgColor: '#143C5F',
              textColor: '#fff',
            },

            {
              imageUrl: require('./images/road-trip-duffle/v2/perfectly-travel-sized_d.jpg'),
              imageUrlMob: require('./images/road-trip-duffle/v2/perfectly-travel-sized_m.jpg'),
              title: 'Perfectly Travel-Sized',
              description: `
                <p>Made in two sizes, the Medium makes a great weekender bag, and the Large carries enough for a week long trip.</p>
              `,
              bgColor: '#E3D8CA',
              textColor: '#1F1F1F',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.ROAD_TRIP_BACKPACK:
      return {
        featureCards: {
          title: 'Meet The Roadtrip Backpack',
          items: [
            {
              imageUrl: require('./images/road-trip-backpack/v2/wear-it-with-comfort_d.jpg'),
              imageUrlMob: require('./images/road-trip-backpack/v2/wear-it-with-comfort_m.jpg'),
              title: 'Wear It With Comfort',
              description: `
                <p>
                 Articulated, padded straps with sternum support make this pack easy to carry and comfortable.
                </p>
              `,
              bgColor: '#9FB2A8',
              textColor: '#1f1f1f',
            },

            {
              videoUrl: 'https://static.velkybrands.com/v/packed-with-potential.mp4',
              imageUrl: require('./images/road-trip-backpack/v2/packed-with-potential_d.jpg'),
              imageUrlMob: require('./images/road-trip-backpack/v2/packed-with-potential_m.jpg'),
              title: 'Packed With Potential',
              description: `<p>
                Easy access to the laptop sleeve, cargo space, and secure pockets make it simple to reach your gear or answer your phone in one motion.
              </p>`,
              bgColor: '#0A6EA2',
              textColor: '#fff',
            },

            {
              imageUrl: require('./images/road-trip-backpack/v2/built-stronger_d.jpg'),
              imageUrlMob: require('./images/road-trip-backpack/v2/built-stronger_m.jpg'),
              title: 'Built Stronger',
              description: `
                <p>Rugged water-resistant nylon fabrics for protection and durability.</p>
              `,
              bgColor: '#B9A58D',
              textColor: '#1F1F1F',
            },
          ],
        },
        prependSlides: [],
      };

    case ProductTypeId.ULTRA_TOUGH_WAGON:
      return {
        featureCards: {
          title: 'Meet the Ultra-Tough Wagon',
          items: [
            {
              imageUrl: require('./images/ultra-tough-wagon/rtic-tough_d.jpg'),
              imageUrlMob: require('./images/ultra-tough-wagon/rtic-tough_m.jpg'),
              title: 'RTIC Tough',
              description: `
                <p>
                 Infused with the same RTIC toughness that goes into all of our products, this Wagon fits up to a 65QT Original Hard Cooler and handle up to 250 pounds of weight. Plus, the all-terrain rubber wheels will help get you to your destination with ease.
                </p>
              `,
              bgColor: '#EDEDED',
              textColor: '#1f1f1f',
            },
            {
              imageUrl: require('./images/ultra-tough-wagon/pack-and-go_d.jpg'),
              imageUrlMob: require('./images/ultra-tough-wagon/pack-and-go_m.jpg'),
              title: 'Pack & Go',
              description: `
                <p>
                 The unique fold-down tailgate makes it easy to pack up a heavy load and tow it to your destination. Once you’re done, the quad-collapsible, powder-coated steel frame makes it easy to collapse and store.
                </p>
              `,
              bgColor: '#EDEDED',
              textColor: '#1f1f1f',
            },
          ],
        },
      };

    default:
      return {
        prependSlides: [],
        featureCards: {
          title: '',
          items: [],
        },
      };
  }
};
